export default __webpack_public_path__ + "static/media/international.48ae800f.jpg";